import { environment } from '../../../environments/environment';

/**
 * Auth bypass helpers for {@link environment.authBypass}.
 * Bypass is for local development convenience only — skip Okta login while working on UI
 * against the local API. Never enable in deployed environments.
 */

/**
 * Returns true when the app should enforce Okta login before showing protected routes.
 */
export function isOktaAuthRequired(): boolean {
  return !environment.authBypass;
}

/**
 * Returns true when auth bypass is active (local development convenience only).
 */
export function usesDevAuthToken(): boolean {
  return environment.authBypass;
}
